// extracted by mini-css-extract-plugin
export default {"list":"uLMIs","slider-container":"XYeno"};